export const availableCertifications = [
  "Level 1 QBO ProAdvisor",
  "Level 2 QBO ProAdvisor",
  "QBO Payroll ProAdvisor",
  "CleanUp Certification",
] as const;

/** Fallback badge images for certifications that predate Credly URL storage. */
export const certificationImages: Record<string, string> = {
  "Level 1 QBO ProAdvisor": "https://images.credly.com/size/680x680/images/75cdf6da-056f-411a-83d7-f4fa8fcd0fde/blob",
  "Level 2 QBO ProAdvisor": "https://images.credly.com/size/680x680/images/a830f195-ffbb-4789-a1ee-f58c07825a53/blob",
  "QBO Payroll ProAdvisor": "https://images.credly.com/size/680x680/images/f98806e7-c3cb-4c50-b3d8-02d12785e783/blob",
  "CleanUp Certification": "https://images.credly.com/images/addfb3db-3d39-48ec-9a35-2cab5c90ceb4/blob",
};

export const availableReviews = ["ProAdvisor Reviews", "Google Reviews"];
